import type { Company } from '~/domain/shared/company/models/Company'

export function formatCompanySelectLabel (
  company: Pick<Company, 'name' | 'isMain'>,
  headquartersLabel: string
): string {
  if (company.isMain === true) {
    return `${company.name} · ${headquartersLabel}`
  }

  return company.name
}
